import type { SerializedEditorState } from "lexical";

/**
 * Extract plain text content from Lexical editor state
 */
export const getEditorTextContent = (editorState: SerializedEditorState): string => {
  if (!editorState.root?.children) return "";

  return editorState.root.children
    .map((node: any) => {
      if (node.type === "paragraph" && node.children) {
        return node.children.map((child: any) => child.text || "").join("");
      }
      return "";
    })
    .join("\n");
};

/**
 * Convert Lexial editor state to TipTap HTML format
 * Falls back to plain text wrapped in paragraphs
 */
export const lexicalToTipTapHtml = (editorState: SerializedEditorState): string => {
  try {
    // Extract plain text
    const textContent = getEditorTextContent(editorState);

    // Convert to HTML paragraphs
    const paragraphs = textContent
      .split("\n")
      .filter(line => line.trim())
      .map(line => `<p>${line}</p>`)
      .join("");

    return paragraphs || "<p></p>";
  } catch (error) {
    console.error("Error converting Lexical to TipTap HTML:", error);
    // Fallback: return empty paragraph
    return "<p></p>";
  }
};

/**
 * Check if editor state is in Lexical format
 */
export const isLexicalFormat = (editorState: any): boolean => {
  return Boolean(
    editorState &&
    typeof editorState === "object" &&
    editorState.root &&
    Array.isArray(editorState.root.children)
  );
};

/**
 * Check if editor state is in TipTap HTML format
 */
export const isTipTapFormat = (editorState: any): boolean => {
  return Boolean(
    editorState &&
    typeof editorState === "string" &&
    (editorState.startsWith("<") || editorState.trim() === "")
  );
};
